export const FETCHING_IMAGES = "FETCHING_IMAGES";
export const IMAGES_FETCHED = "IMAGES_FETCHED";
export const PAGE = "PAGE";
export const UPLOADING_IMAGES = "UPLOADING_IMAGES";
export const IMAGES_UPLOADED = "IMAGES_UPLOADED";
export const SHOW_PROGRESS_DIALOG = "SHOW_PROGRESS_DIALOG";
export const HIDE_PROGRESS_DIALOG = "HIDE_PROGRESS_DIALOG";


// WEBPACK FOOTER //
// ./src/actions/constants.js